// REACT
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AnimatePresence } from "framer-motion";

// CONTEXT
import { mainContext } from "./context/mainContext.js";

// SERVICES
import { router } from "./routes/router.js";
import { saveLanguageToCookie, getLanguageFromCookie } from "./services/languageService";
import { detectBrowserLang } from "./services/detectBrowserLang.js";

// PAGES
import SplashScreen from "./pages/SplashScreen.js";

function App() {
  const [navHeight, setNavHeight] = useState(0);
  const [navActive, setNavActive] = useState("");

  const [language, setLanguage] = useState(() => {
    const cookieLang = getLanguageFromCookie();
    return cookieLang || detectBrowserLang();
  });

  // splash visibility; when it goes false, the app is "ready"
  const [showSplash, setShowSplash] = useState(true);
  const appReady = !showSplash; // <-- gate value we’ll pass down

  /* language sync */
  useEffect(() => {
    const storedLang = getLanguageFromCookie();
    if (storedLang && storedLang !== language) setLanguage(storedLang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    saveLanguageToCookie(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  /* avoid scroll restore jumpiness */
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <div id="AppDiv">
      <HelmetProvider>
        <mainContext.Provider
          value={{
            navHeight, setNavHeight,
            navActive, setNavActive,
            language, setLanguage,
            appReady, // <-- expose to pages/components
          }}
        >
          {/* Always render the app for SEO */}
          <RouterProvider router={router} />

          {/* Visual overlay on top */}
          <AnimatePresence>
            {showSplash && <SplashScreen onFinish={() => setShowSplash(false)} />}
          </AnimatePresence>
        </mainContext.Provider>
      </HelmetProvider>
    </div>
  );
}

export default App;
